import React, { useState } from "react";
import { Button, Icon, Transition } from "semantic-ui-react";
import { signInWithGoogle } from "../Pages/SignIn";
import { auth, firebase } from "../utils/firebase";
import AdminContent from "./AdminContent";
const style = {
  root: {
    position: "absolute",    
    top: "0px",
    right: "15px",
  },
  fixedButtonGroupContainer: {
    position: "absolute",
    top: "15px",
    right: "15px",
  },
  buttonGroup: {
    marginTop: "60px",
  },
  icon:{
    "background-color":"#e5e5e5"
  },
  avatar: {
    height: "40px",
    width: "40px",
    "border-radius": "50%",
    border: "solid 5px rgb(165 165 165 / 33%)",
    margin: "auto",
  },
};

function PopupMenu() {
  const [visible, setVisible] = useState(false);

  /* 網頁設定按鈕 */
  return (
    <div style={style.root}>
      <button
        style={style.fixedButtonGroupContainer}
        onClick={() => {
          setVisible(!visible);
        }}
      >
        {auth.currentUser ? (
          <img
            as="i"
            className="ui circular icon"
            src={auth.currentUser.photoURL}
            style={style.avatar}
          ></img>
        ) : (
          <Icon name="bars" className="ui circular icon" style={style.icon}></Icon>
        )}
      </button>
      <Transition.Group animation="slide left" duration={500}>
        {visible && (
          <Button.Group basic vertical style={style.buttonGroup}>
            {!auth.currentUser && (
              <Button onClick={signInWithGoogle}>登入</Button>
            )}

            {auth.currentUser && (
              <Button
                onClick={() => {
                  firebase.auth().signOut();
                }}
              >
                登出
              </Button>
            )}

            {/* 後台 */}
            <AdminContent>
              <Button
                onClick={() => {
                  window.location.href="/my";
                }}
              >
                管理
              </Button>
            </AdminContent>
          </Button.Group>
        )}
      </Transition.Group>
    </div>
  );
}

export default PopupMenu;
